// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrap_tStT5{align-items:center;display:flex;gap:8px;justify-content:space-between}@media only screen and (min-width:1264px){.wrap_tStT5{align-items:center;flex-direction:column;justify-content:flex-start;margin-right:-97px}}.count_9nEpG{color:var(--cp-color-73);font-size:12px;line-height:20px}.count_9nEpG.isOpactiy_9ou\\+J{opacity:0}.btn_gAgOL{display:block;width:87px}.btn_gAgOL.is_boutique_7x4Qg{--cp-primary_main:var(--cp-black);--cp-secondary_main:var(--cp-black);--cp-primary_main_darker:var(--cp-black);--cp-secondary-4:var(--cp-color-6)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": "wrap_tStT5",
	"count": "count_9nEpG",
	"isOpactiy": "isOpactiy_9ou+J",
	"btn": "btn_gAgOL",
	"is_boutique": "is_boutique_7x4Qg"
};
module.exports = ___CSS_LOADER_EXPORT___;
